// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__Dnr3v","left":"InfoRow_left__2t_iN"};